import React, { useRef, useState } from 'react'
import { Modal } from 'react-bootstrap'
import Button from '@components/common/Button/Button.component'
import ProviderSettingsForm, {
  ProviderSettingsFormHandle,
} from './ProviderSettingsForm.component'
import ConfirmationModal from '@components/common/ConfirmationModal/ConfirmationModal.component'
import './ProcedureSettings.css'

const ProcedureSettingsModal = ({
  isVisible,
  closeModal,
}: {
  isVisible: boolean
  closeModal: () => void
}): React.ReactElement => {
  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false)
  const providerSettingsFormRef = useRef<ProviderSettingsFormHandle>(null)

  const handleSaveButtonClick = (): void => {
    setShowConfirmModal(true)
  }

  const handleConfirmSave = (): void => {
    setShowConfirmModal(false)
    providerSettingsFormRef.current?.handleSave()
  }

  const handleCancel = (): void => {
    closeModal()
  }

  return (
    <>
      <Modal
        show={isVisible}
        onHide={handleCancel}
        size="lg"
        backdrop="static"
        className="procedure-settings-modal"
        dialogClassName="custom-modal-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>DXC Claim Provider Settings</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ProviderSettingsForm ref={providerSettingsFormRef} />
        </Modal.Body>
        <Modal.Footer>
          <Button className="button-secondary me-1" onClick={handleCancel}>
            Cancel
          </Button>
          <Button className="button-primary" onClick={handleSaveButtonClick}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <ConfirmationModal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        title="Confirm save"
        body={<p>Are you sure you want to save the changes?</p>}
        footer={
          <>
            <Button
              className="button-secondary me-1"
              onClick={() => setShowConfirmModal(false)}
            >
              Cancel
            </Button>
            <Button className="button-primary" onClick={handleConfirmSave}>
              Confirm
            </Button>
          </>
        }
      />
    </>
  )
}

export default ProcedureSettingsModal
